import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const PaymentModeGauges = ({ paymentStats }) => {
  // Extract payment data
  const { paymentTotals, paymentCounts, totalAmount } = paymentStats;

  // Calculate percentages 
  const getPercentage = (amount) => {
    return totalAmount > 0 ? ((amount / totalAmount) * 10).toFixed(1) : 0;
  };

  // Prepare gauge data
  const paymentModes = [
    {
      name: "Cash",
      value: paymentTotals.cash || 0,
      count: paymentCounts.cash || 0,
      percentage: getPercentage(paymentTotals.cash),
      color: "#4CAF50" // Green
    },
    {
      name: "Card",
      value: paymentTotals.card || 0,
      count: paymentCounts.card || 0,
      percentage: getPercentage(paymentTotals.card),
      color: "#FFC107" // Yellow
    },
    {
      name: "UPI",
      value: paymentTotals.online || 0,
      count: paymentCounts.online || 0,
      percentage: getPercentage(paymentTotals.online),
      color: "#FF9800" // Orange
    },
    {
      name: "Loan",
      value: paymentTotals.cheque || 0,
      count: paymentCounts.cheque || 0,
      percentage: getPercentage(paymentTotals.cheque),
      color: "#F44336" // Red
    }
  ];

  // Format currency
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR'
    }).format(amount);
  };

  const createGaugeChart = (data) => {
    // Create gauge chart data (partial circle)
    const gaugeData = [
      { name: "filled", value: Number(data.percentage) },
      { name: "empty", value: 10 - Number(data.percentage) }
    ];

    return (
      <div className="gauge-card">
        <h3>{data.name}</h3>
        <div className="gauge-container">
          <PieChart width={150} height={150}>
            <Pie
              data={gaugeData}
              cx="50%"
              cy="50%"
              startAngle={180}
              endAngle={0}
              innerRadius={40}
              outerRadius={60}
              cornerRadius={5}
              paddingAngle={0}
              dataKey="value"
              stroke="none"
            >
              <Cell fill={data.color} />
              <Cell fill="#e0e0e0" />
            </Pie>
          </PieChart>
          <div className="gauge-value">{data.count}</div>
        </div>
        <div className="gauge-details">
          <p className="amount">{formatCurrency(data.value)}</p>
          <p className="count">No. Admission: {data.count}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="payment-gauges-container">
      {paymentModes.map((mode) => createGaugeChart(mode))}
    </div>
  );
};

export default PaymentModeGauges;